
.vs-form .vs-text a.error-link,
.vs-form .vs-text a.error-link:hover,
.vs-form .vs-text a.error-link:focus {
  color: #D50000;
  color: var(--text-error);
}

.spinner {
  display: inline-block;
  position: relative;
  width: 150px;
  height: 150px;
}
.spinner div {
  animation: spinner 2.5s infinite;
  transform-origin: 75px 75px;
}
.spinner div:after {
  content: " ";
  display: block;
  box-sizing: border-box;
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 6px solid #1434CB;
  background: #1434CB;
  margin: -7px 0 0 -7px;
}
.spinner div:nth-child(1):after {
  top: 118px;
  left: 118px;
}
.spinner div:nth-child(2) {
  animation-delay: -0.025s;
}
.spinner div:nth-child(2):after {
  top: 127px;
  left: 105px;
}
.spinner div:nth-child(3) {
  animation-delay: -0.05s;
}
.spinner div:nth-child(3):after {
  top: 133px;
  left: 90px;
}
.spinner div:nth-child(4) {
  animation-delay: -0.075s;
}
.spinner div:nth-child(4):after {
  top: 135px;
  left: 75px;
}
.spinner div:nth-child(5) {
  animation-delay: -0.1s;
}
.spinner div:nth-child(5):after {
  top: 133px;
  left: 60px;
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
    opacity: 0;
    animation-timing-function: ease-out;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    transform: rotate(670deg);
    opacity: 0;
    animation-timing-function: ease-out;
  }
}

@media screen and (prefers-reduced-motion: reduce), (update: slow) {
  .spinner div {
    display: none;
  }
}
